import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const SuccessModal = ({ onFinish, theme, logoLight, jobTitle }) => {
  return (
    <div className='ai-interview-container'>
      {/* Same header as interview interface */}
      <div className='d-flex align-items-center justify-content-between w-100 position-fixed interview-header'>
        <div className='d-flex align-items-center'>
          <img
            role='button'
            onClick={onFinish}
            className='light-image ml-4'
            style={{ height: '50px' }}
            src={
              theme?.loginLogo && theme.loginLogo.url
                ? theme.loginLogo.url
                : logoLight
            }
            alt=''
          />
          <div className='job-title-header'>
            <h1 className='text-white m-0'>
              {jobTitle
                ? `AI Interview - ${jobTitle}`
                : 'AI Interview Complete'}
            </h1>
          </div>
        </div>
      </div>

      {/* Main content with same styling as interview */}
      <div
        className='d-flex flex-column justify-content-center align-items-center min-vh-100 text-white p-4'
        style={{ paddingTop: '100px' }}
      >
        <div className='text-center' style={{ maxWidth: '600px' }}>
          <FontAwesomeIcon
            icon={faCheckCircle}
            size='4x'
            className='text-success mb-4'
          />

          <div className='bg-success p-4 rounded mb-4'>
            <h4 className='text-white mb-3'>
              Interview Completed Successfully!
            </h4>
            <p className='mb-0 text-white'>
              Thank you for taking the time to complete your AI interview.
            </p>
          </div>

          <div className='bg-secondary p-4 rounded mb-4'>
            <h4 className='text-info mb-3'>What's Next?</h4>
            <ul className='list-unstyled text-dark mb-0'>
              <li>
                ✅ Your interview has been{' '}
                <strong>successfully recorded</strong> and saved.
              </li>
              <li>
                ⏰ Our team will review your responses and{' '}
                <strong>contact you soon</strong>.
              </li>
              <li>🤝 Thank you for your interest in joining our team!</li>
            </ul>
          </div>

          <div className='text-center'>
            <button className='btn btn-primary btn-lg px-4' onClick={onFinish}>
              Return to Homepage
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SuccessModal
